import React, { useState } from "react";
import "../css/contactus.scss";
import { SITE_CONFIG } from "../config/siteConfig";

function Contact() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    orderNumber: "",
    subject: "",
    message: "",
  });
  const [errors, setErrors] = useState({});

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((current) => ({ ...current, [name]: value }));
    setErrors((current) => ({ ...current, [name]: "" }));
  };

  const validateForm = () => {
    const nextErrors = {};
    if (!formData.firstName.trim()) nextErrors.firstName = "First name is required";
    if (!formData.lastName.trim()) nextErrors.lastName = "Last name is required";
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) nextErrors.email = "Enter a valid email";
    if (!formData.subject) nextErrors.subject = "Choose a subject";
    if (formData.message.trim().length < 10) nextErrors.message = "Please provide at least 10 characters";
    return nextErrors;
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const nextErrors = validateForm();
    setErrors(nextErrors);
    if (Object.keys(nextErrors).length > 0) {
      document.getElementById(Object.keys(nextErrors)[0])?.focus();
      return;
    }
    const subject = `${formData.subject}${formData.orderNumber ? ` — ${formData.orderNumber}` : ""}`;
    const body = [
      `Name: ${formData.firstName} ${formData.lastName}`,
      `Reply email: ${formData.email}`,
      formData.orderNumber ? `Order: ${formData.orderNumber}` : "",
      "",
      formData.message,
    ].filter(Boolean).join("\n");
    window.location.href = `mailto:${SITE_CONFIG.supportEmail}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  };

  return (
    <div className="contact">
      <div className="page-width page-width--narrow">
        <h1 className="main-page-title">Contact Us</h1>
        <div className="contact-container">
          <div className="contact-info">
            <h3>Customer care</h3>
            <p>Use the form to open an email draft in your own mail application. The website does not pretend to send or store the message.</p>
            <div className="info-item">
              <strong>Region</strong>
              <p>{SITE_CONFIG.operatingRegion}</p>
            </div>
            <div className="info-item">
              <strong>Email</strong>
              <p><a href={`mailto:${SITE_CONFIG.supportEmail}`}>{SITE_CONFIG.supportEmail}</a></p>
            </div>
          </div>

          <form className="contact-form" onSubmit={handleSubmit} noValidate>
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="firstName">First Name</label>
                <input id="firstName" name="firstName" value={formData.firstName} onChange={handleInputChange} aria-invalid={Boolean(errors.firstName)} />
                {errors.firstName && <span className="error-text">{errors.firstName}</span>}
              </div>
              <div className="form-group">
                <label htmlFor="lastName">Last Name</label>
                <input id="lastName" name="lastName" value={formData.lastName} onChange={handleInputChange} aria-invalid={Boolean(errors.lastName)} />
                {errors.lastName && <span className="error-text">{errors.lastName}</span>}
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input type="email" id="email" name="email" value={formData.email} onChange={handleInputChange} aria-invalid={Boolean(errors.email)} />
              {errors.email && <span className="error-text">{errors.email}</span>}
            </div>
            <div className="form-group">
              <label htmlFor="orderNumber">Order number (optional)</label>
              <input id="orderNumber" name="orderNumber" value={formData.orderNumber} onChange={handleInputChange} />
            </div>
            <div className="form-group">
              <label htmlFor="subject">Subject</label>
              <select id="subject" name="subject" value={formData.subject} onChange={handleInputChange} aria-invalid={Boolean(errors.subject)}>
                <option value="">Select a subject</option>
                <option value="Order support">Order support</option>
                <option value="Product information">Product information</option>
                <option value="Return or damage">Return or damage</option>
                <option value="Privacy request">Privacy request</option>
                <option value="Accessibility">Accessibility</option>
                <option value="Other">Other</option>
              </select>
              {errors.subject && <span className="error-text">{errors.subject}</span>}
            </div>
            <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea id="message" name="message" rows="6" value={formData.message} onChange={handleInputChange} aria-invalid={Boolean(errors.message)} />
              {errors.message && <span className="error-text">{errors.message}</span>}
            </div>
            <button type="submit" className="btn-submit">Open email draft</button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Contact;
